<template>
  <BaseModal
    name="toMoveCost"
    width="420"
    height="auto"
    :clickToClose="false"
    :shiftY="0.5"
    :adaptive="true"
    classes="!tw-bg-transparent !tw-shadow-none !tw-overflow-visible"
    @before-close="
      () => {
        foundFrom = [];
      }
    "
    @before-open="loadData"
  >
    <div
      class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
    >
      <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>

      <button
        type="button"
        class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
        @click="$modal.hide('toMoveCost')"
      ></button>

      <div class="tw-text-center">
        <div class="tw-text-[23px] tw-mb-[15px]">
          <div v-if="typeOperation == 'transit'">
            {{ dataLang["reg_fin_text_59"] }}
          </div>
          <div v-if="typeOperation == 'coming'">
            {{ dataLang["reg_fin_text_52"] }}
          </div>
          <div v-if="typeOperation == 'clientPayment'">
            {{ dataLang["reg_fin_text_62"] }}
          </div>
          <div v-if="typeOperation == 'spend'">
            {{ dataLang["reg_fin_text_66"] }}
          </div>
        </div>

        <div class="tw-mb-[15px]" ref="finreestr__amount">
          <div class="tw-app-input-type-3-label">
            {{ dataLang["reg_fin_text_105"] }}
          </div>
          <BaseInputNew
            inputClass="tw-app-input-type-3"
            @input="updateValue"
            input-name="finreestr__amount"
            :forFinanceType="true"
            inputRef="finreestr__amount__1"
          >
          </BaseInputNew>
        </div>

        <div
          class="tw-mb-[15px]"
          v-if="typeOperation == 'coming' || typeOperation == 'clientPayment'"
          ref="finreestr__type_payment_id"
        >
          <div class="multiselect-type-3-label">
            <div v-if="typeOperation == 'clientPayment'">
              {{ dataLang["reg_fin_text_60"] }}
            </div>
            <div v-if="typeOperation == 'coming'">
              {{ dataLang["reg_fin_text_54"] }}
            </div>
          </div>
          <BaseSelect
            class="multiselect-type-3"
            style="position: relative; z-index: 10000"
            selectLabel=""
            v-if="!localLoading"
            deselectLabel=""
            :maxHeight="300"
            openDirection="bottom"
            @input="
              ({ finreestr_funds__id }) =>
                updateValue({
                  name: 'finreestr__type_payment_id',
                  value: finreestr_funds__id,
                })
            "
            v-model="foundFrom"
            :options="listOptions"
            label="finreestr_funds__name"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template
            ><template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>

        <div
          class="tw-mb-[15px]"
          v-if="typeOperation == 'clientPayment'"
          ref="finreestr__client_id"
        >
          <div class="multiselect-type-3-label">
            {{ dataLang["reg_fin_text_55"] }}
          </div>

          <BaseSelect
            class="multiselect-type-3"
            style="position: relative; z-index: 9000"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            v-if="!localLoading"
            :maxHeight="300"
            openDirection="bottom"
            @input="
              ({ clients__id }) =>
                updateValue({
                  name: 'finreestr__client_id',
                  value: clients__id,
                })
            "
            v-model="contragentSelect"
            :options="contragentSelectOptions"
            :customLabel="
              ({ clients__name, clients__id, clients__balance }) =>
                `${clients__name} (${clients__id}) ${dataLang['reg_fin_text_12']} ${clients__balance}`
            "
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template
            ><template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>

        <div
          class="tw-mb-[15px]"
          v-if="typeOperation == 'transit'"
          ref="finreestr__from_fund_id"
        >
          <div class="multiselect-type-3-label">
            {{ dataLang["reg_fin_text_60"] }}
          </div>
          <BaseSelect
            class="multiselect-type-3"
            style="position: relative; z-index: 8000"
            placeholder=""
            selectLabel=""
            :maxHeight="300"
            openDirection="bottom"
            v-if="!localLoading"
            deselectLabel=""
            @input="
              ({ finreestr_funds__id }) =>
                updateValue({
                  name: 'finreestr__from_fund_id',
                  value: finreestr_funds__id,
                })
            "
            v-model="foundFrom"
            :options="listOptions"
            label="finreestr_funds__name"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template
            ><template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>

        <div
          class="tw-mb-[15px]"
          v-if="typeOperation == 'transit'"
          ref="finreestr__to_fund_id"
        >
          <div class="multiselect-type-3-label">
            {{ dataLang["reg_fin_text_61"] }}
          </div>
          <BaseSelect
            class="multiselect-type-3"
            style="position: relative; z-index: 7000"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            openDirection="bottom"
            v-if="!localLoading"
            :maxHeight="300"
            @input="
              ({ finreestr_funds__id }) =>
                updateValue({
                  name: 'finreestr__to_fund_id',
                  value: finreestr_funds__id,
                })
            "
            v-model="foundTo"
            :options="listMove"
            label="finreestr_funds__name"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template
            ><template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>

        <div
          class="tw-mb-[15px]"
          v-if="typeOperation == 'spend'"
          ref="finreestr__type_payment_id"
        >
          <div class="multiselect-type-3-label">
            {{ dataLang["reg_fin_text_67"] }}
          </div>
          <BaseSelect
            class="multiselect-type-3"
            style="position: relative; z-index: 6000"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            openDirection="bottom"
            :maxHeight="300"
            v-if="!localLoading"
            @input="
              ({ finreestr_funds__id }) =>
                updateValue({
                  name: 'finreestr__type_payment_id',
                  value: finreestr_funds__id,
                })
            "
            v-model="foundFrom"
            :options="listOptions"
            label="finreestr_funds__name"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template
            ><template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>

        <div
          v-if="typeOperation == 'coming' || typeOperation == 'spend'"
          ref="finreestr__contragent"
          class="tw-mb-[15px]"
        >
          <div class="tw-app-input-type-3-label">
            {{ dataLang["reg_fin_text_55"] }}
          </div>
          <BaseInputNew
            inputClass="tw-app-input-type-3"
            input-name="finreestr__contragent"
            @input="updateValue"
          />
        </div>

        <div
          v-if="typeOperation == 'coming'"
          ref="finreestr__basis"
          class="tw-mb-[15px]"
        >
          <div class="tw-app-input-type-3-label">
            {{ dataLang["reg_fin_text_56"] }}
          </div>
          <BaseInputNew
            inputClass="tw-app-input-type-3"
            input-name="finreestr__basis"
            @input="updateValue"
          />
        </div>

        <div class="tw-mb-[15px]">
          <BaseTextarea
            v-if="typeOperation == 'spend'"
            input-class="tw-app-input-type-3 tw-m-w-[360px]"
            input-name="finreestr__basis"
            @onInput="updateValue"
            :minHeight="'96'"
          >
          </BaseTextarea>
        </div>

        <div>
          <div class="tw-app-input-type-3-label">Дата</div>
          <BaseDatePicker
            class="tw-w-full"
            input-class="tw-app-input-type-3 tw-w-full"
            @changes="updateValue({ name: `created_at`, value: $event })"
            @change="$set(dataForEmit, `created_at`, $event)"
            :show-hour="true"
            :show-time-header="true"
            :value="dataForEmit.created_at || getNowDateTime()"
            type="datetime"
            :format="`DD.MM.YYYY HH:mm`"
            lang="ru"
            value-type="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledFutureDates"
          >
          </BaseDatePicker>
        </div>

        <!-- separator -->
        <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
          <button
            @click="$modal.hide('toMoveCost')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            {{ dataLang["reg_fin_text_57"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            {{ dataLang["reg_fin_text_58"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VeTable } from "vue-easytable";
import BidsService from "@/api/BidsService";
import EventBus from "@/event-bus.js";
import OwnersService from "@/api/OwnersService";

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  components: {
    VeTable,
  },

  props: {},
  data() {
    return {
      contragentSelect: [],
      contragentSelectOptions: [],
      listOptions: [],
      typeOperation: "",
      localLoading: false,
      dataForEmit: {},
      foundFrom: [],
      listMove: [],
      foundTo: [],
      currentId: null,
    };
  },
  methods: {
    disabledFutureDates(date) {
      return date > new Date();
    },
    loadData({ params }) {
      this.localLoading = true;
      this.typeOperation = params?.type;
      Promise.all([
        this.typeOperation == "transit" || this.typeOperation == "spend"
          ? GeneralService.get("/finreestr-funds")
              .then((data) => {
                this.listOptions = data.data.data.rows.filter(
                  (www) => www.finreestr_funds__code !== "fund_1"
                );

                this.listOptions.forEach((e, index) => {
                  if (this.dataLang[e.finreestr_funds__name]) {
                    e.finreestr_funds__name =
                      this.dataLang[e.finreestr_funds__name];
                  }
                });
                this.currentId = params?.datas?.finreestr_funds__id;

                this.dataForEmit["finreestr__type_payment_id"] = this.currentId;

                if (this.currentId && this.listOptions.length) {
                  let findIndexed = this.listOptions.findIndex(
                    (x) => x.finreestr_funds__id == this.currentId
                  );

                  this.foundFrom = this.listOptions[findIndexed];
                }
                if (this.typeOperation == "transit") {
                  this.dataForEmit["finreestr__from_fund_id"] = this.currentId;
                }
              })
              .catch((e) => {})
          : "",

        this.typeOperation == "transit"
          ? GeneralService.get("/finreestr-funds")
              .then((data) => {
                this.listMove = data.data.data.rows.filter(
                  (www) => www.finreestr_funds__code !== "fund_1"
                );
                this.listMove.forEach((e, index) => {
                  if (this.dataLang[e.finreestr_funds__name]) {
                    e.finreestr_funds__name =
                      this.dataLang[e.finreestr_funds__name];
                  }
                });
              })
              .catch((e) => {})
          : "",

        this.typeOperation == "clientPayment" || this.typeOperation == "coming"
          ? GeneralService.get(
              '/finreestr-funds?where=[{"field":"finreestr_funds__is_coming","value":1}]&fields=finreestr_funds__id,finreestr_funds__name,finreestr_funds__code,finreestr_funds__is_coming'
            )
              .then((data) => {
                this.listOptions = data.data.data.rows.filter(
                  (www) => www.finreestr_funds__code !== "fund_1"
                );
                this.currentId = params?.datas?.finreestr_funds__id;

                this.dataForEmit["finreestr__type_payment_id"] = this.currentId;

                this.listOptions.forEach((e, index) => {
                  if (this.dataLang[e.finreestr_funds__name]) {
                    e.finreestr_funds__name =
                      this.dataLang[e.finreestr_funds__name];
                  }
                });

                if (this.currentId && this.listOptions.length) {
                  let findIndexed = this.listOptions.findIndex(
                    (x) => x.finreestr_funds__id == this.currentId
                  );

                  this.foundFrom = this.listOptions[findIndexed];
                }
                if (this.typeOperation == "transit") {
                  this.dataForEmit["finreestr__from_fund_id"] = this.currentId;
                }
              })
              .catch((e) => {})
          : "",

        GeneralService.get(
          "/clients/table/active?count=0&limit=100&total=0&page=0"
        )
          .then((data) => {
            this.contragentSelectOptions = data.data.data.rows;
          })
          .catch((e) => {}),
      ])
        .then(() => {})
        .finally(() => {
          this.localLoading = false;
        });

      // /clients/table/active?count=0&limit=100&total=0&page=0
    },
    beforeClose(event) {
      this.dataForEmit = {};
      this.currentId = null;
      this.foundFrom = [];
      this.foundTo = [];
    },
    updateValue(data) {
      // this.dataForEmit[data.name] = data.value;
      this.$set(this.dataForEmit, data.name, data.value);
      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
      //   this.$refs[data.name].classList.remove('input-error')
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    sendData() {
      if (Object.keys(this.dataForEmit).length) {
        this.localLoading = true;
        GeneralService.editOrCreate(`/finreestr`, {
          finreestr__action: this.typeOperation,
          ...this.dataForEmit,
          finreestr__amount: this.dataForEmit?.finreestr__amount?.replace(
            ",",
            "."
          ),
        })
          .then((data) => {
            this.$toast.success(data.data.message);
            this.dataForEmit = {};
            this.$modal.hide("toMoveCost");
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
            setTimeout(() => {
              Object.keys(e.response.data.errors).forEach((elem, index) => {
                if (this.$refs[elem]) {
                  this.$refs[elem].classList.add("input-error");
                }
              });
            }, 10);
          })
          .finally(() => {
            this.localLoading = false;
            this.foundFrom = [];
            this.foundTo = [];
            EventBus.$emit("updateModalsFin");
          });
      }
    },
    getNowDateTime() {
      const now = new Date();
      const pad = (n) => n.toString().padStart(2, "0");
      const day = pad(now.getDate());
      const month = pad(now.getMonth() + 1); // Months are 0-indexed
      const year = now.getFullYear();
      const hours = pad(now.getHours());
      const minutes = pad(now.getMinutes());
      const seconds = pad(now.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
